import { Link } from "react-router-dom"
import { getInitials } from "../../utils/getInitials"
import { formatDate, getAge } from "../../utils/utils"
import Resume from "../resume"
import { OverlayTrigger, Tooltip, Badge, Popover, Table } from "react-bootstrap";

const StudentCard = ({ student }) => {
    const AWS = process.env.REACT_APP_AWS_HOST;
    const radius = 36;
    const circumference = 2 * Math.PI * radius;
    const progress = student?.profile_progress || 0;

    return (
        <div className="card-body padnone">
            <div style={{ position: "relative" }}>
                <div className="gallery-box card fillcolor" style={{ padding: 0 }}>
                <div
                    className="card mb-0 yellowborder"
                    style={{ minHeight: "225px" }}
                >
                    <div className="d-flex position-relative">
                    <div className="card-body">

                        <div className="border-0">
                            <div className="h-100 student-card">
                                <div
                                className="bg-gradient text-white text-center position-relative"
                                style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}
                                >
                                {student?.is_premium === 1 && (
                                    <div className="position-absolute top-0 start-0 m-2">
                                    <span className="badge bg-warning text-dark rounded-pill px-2 py-1">
                                        <i className="bi bi-star-fill me-1"></i>Premium
                                    </span>
                                    </div>
                                )}
                                <div className="profile-avatar mx-auto mb-3 mt-3">
                                    <div
                                        className="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white mx-auto position-relative"
                                        style={{
                                        width: "80px",
                                        height: "80px",
                                        fontSize: "1.5rem",
                                        fontWeight: "bold",
                                        overflow: "hidden",
                                        }}
                                    >
                                        <div
                                            className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center bg-primary text-white"
                                            style={{
                                            width: "68px",
                                            height: "68px",
                                            fontSize: "1.4rem",
                                            fontWeight: "bold",
                                            zIndex: 1,
                                            }}
                                        >

                                        {student?.profile_image ? (
                                            <img
                                                src={`${AWS}${student?.profile_image}`}
                                                alt="user-img"
                                                className="rounded-circle"
                                                style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                }}
                                                onError={(e) => {
                                                e.target.src = "/assets/images/avtar.png";
                                                }}
                                            />
                                            ) : (
                                            getInitials(student?.first_name, student?.last_name)
                                            )}
                                        </div>

                                        <svg
                                        className="position-absolute top-0 start-0"
                                        width="80"
                                        height="80"
                                        viewBox="0 0 80 80"
                                        style={{ transform: "rotate(-90deg)", pointerEvents: "none" }}
                                        >
                                        <circle
                                            cx="40"
                                            cy="40"
                                            r="36"
                                            fill="none"
                                            stroke="rgba(255,255,255,0.3)"
                                            strokeWidth="4"
                                        />
                                        <circle
                                            cx="40"
                                            cy="40"
                                            r="36"
                                            fill="none"
                                            stroke="#FFD700"
                                            strokeWidth="4"
                                            strokeLinecap="round"
                                            strokeDasharray={circumference}
                                            strokeDashoffset={circumference - (progress / 100) * circumference}
                                        />
                                        </svg>
                                    </div>
                                </div>


                                <h5 className="card-title mb-1 fw-bold">
                                    {student?.first_name} {student?.last_name}
                                </h5>
                                {/* <p className="card-title mb-2" style={{ fontSize: "0.9rem",height:42 }}>
                                    {student?.student_detail?.institution_name || "Institution Not Specified"}
                                </p> */}
                                </div>

                                <div className="card-body p-2 ">
                                <div className="mb-1 border-top pt-1">
                                    <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-envelope text-primary me-2"></i>
                                    <small className="text-muted text-truncate">{student?.email ? student?.email : "N/A"}</small>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-telephone text-success me-2"></i>
                                    <small className="text-muted">{student?.contact_number ? student?.contact_number : "N/A"}</small>
                                    </div>
                                </div>
                                {student?.state ? (
                                    <div className="mb-2">
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-geo-alt text-danger me-2"></i>
                                        <small className="text-muted">
                                        {student?.state_name ? <>{student?.city_name},{student?.state_name}</> : "N/A"}
                                        {student?.gender && (
                                            <span className="ms-2   text-capitalize">
                                            <i className={`bi ${student?.gender === "male" ? "bi-gender-male text-primary" : "bi-gender-female text-pink"} me-1`}></i>
                                            {student?.gender.charAt(0).toUpperCase() + student?.gender.slice(1)}
                                            </span>
                                        )}
                                        </small>
                                    </div>
                                    </div>
                                ) : <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-geo-alt text-danger me-2"></i>
                                    <small className="text-muted">
                                    N/A
                                    <span className="ms-2">
                                        <i
                                        className={`bi ${student?.gender === "male" ? "bi-gender-male text-primary" : "bi-gender-female text-pink"} me-1`}
                                        ></i>
                                        Not Identify
                                    </span>
                                    </small>
                                </div>
                                }
                                {student?.student_detail && (
                                    <div className="mb-3">
                                        <div className="row g-2 text-center">
                                            <div className="col-6">
                                            <div className="bg-light rounded p-2">
                                                <div className="fw-semibold text-primary" style={{ fontSize: "0.9rem" }}>
                                                {student?.student_detail?.degree_status || "N/A"}
                                                </div>
                                                <small className="text-muted">Degree Status</small>
                                            </div>

                                            </div>
                                            <div className="col-6">
                                            <div className="bg-light rounded p-2">
                                                <div className="fw-semibold text-success" style={{ fontSize: "0.9rem" }}>
                                                {getAge(student?.student_detail?.date_of_birth) || "N/A"}
                                                </div>
                                                <small className="text-muted">Age</small>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="border-top pt-1 mb-2">
                                    <small className="text-muted d-block mb-2 text-uppercase fw-semibold" style={{ fontSize: 11, letterSpacing: "0.5px" }}>
                                        Education
                                    </small>
                                    <div className="d-flex flex-wrap gap-1">
                                        <EductionCell eductionList={student?.education_details?.map((ed)=>ed?.degree_title) || []} numShow={3} isGrid={true} studentEdu={student.education_details}/>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <SkillsCell skillsCsv={student?.skills} numShow={2}/>
                                </div>

                                <div className="bg-light rounded-4">
                                    <div className=" pt-3 mt-3">
                                        <div className="row g-2 text-center">
                                        <div className="col-6">
                                            <small className="text-muted d-block">Total Experience</small>
                                            <span className="fw-semibold text-primary">{student?.total_experience ? `${student?.total_experience} years` : "0"}</span>
                                        </div>
                                        <div className="col-6">
                                            <small className="text-muted d-block">Joined</small>
                                            <span className="fw-semibold text-success">{formatDate(student?.created_at)}</span>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="card-footer bg-transparent border-top-0 pt-1">
                                    <div className="row g-2">
                                        <div className="col-sm">
                                        <Link to={`/student-profile/${student.id}`} className="btn w-100 btn-primary btn-sm rounded-pill fw-semibold">
                                            <i className="bi bi-eye me-2"></i>View Profile
                                        </Link>
                                        </div>
                                        <div className="col-sm px-0">
                                            <Resume studentInfo={student} id={student.id}/>
                                        </div>
                                    </div>
                                    </div>
                                </div>

                                </div>

                            </div>
                        </div>

                    </div>

                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

export function SkillsCell({ skillsCsv, numShow=3, isTable, isApp=false }) {
    // console.log("skkks",skillsCsv)
  const skills = isApp ?skillsCsv: skillsCsv?.split(",")?.map(s => s?.trim())?.filter(Boolean) ?? [];
  const preview = skills?.slice(0, numShow);
  const hiddenCount = Math.max(skills.length - preview.length, 0);

    const renderPopover = (
        <Popover
            id="skills-popover"
            style={{
                boxShadow: "2px 4px 12px rgba(0,0,0,0.15)",
                borderRadius: "8px",
            }}
        >
            <Popover.Header as="h6" className="fw-semibold">Skills List</Popover.Header>
            <Popover.Body style={{ maxHeight: "auto", overflowY: "auto" }}>
                <div className="d-flex flex-wrap gap-1">
                    {skills.map((skill, i) => (
                    <Badge
                        key={i}
                        bg="primary"
                        className="bg-opacity-10 border border-primary border-opacity-25"
                        style={{ fontSize: 11, 
                            fontWeight: 500, 
                            padding: "4px 8px",
                            maxWidth: 200,
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            display: "inline-block"
                        }}
                    >
                        {skill}
                    </Badge>
                    ))}
                </div>
            </Popover.Body>
        </Popover>
    );
  return (
    <>
        {isTable || isApp ||
            <small className="text-muted d-block mb-2 text-uppercase fw-semibold" style={{ fontSize: 11, letterSpacing: "0.5px" }}>
                Skills
            </small>
        }

      {preview?.length === 0 ? "No Skills." :(
        <OverlayTrigger
            placement="auto"
            overlay={renderPopover}
            delay={{ show: 100, hide: 200 }}
        >
            <div className="d-flex flex-wrap gap-1 cursor-pointer">
                {isTable ||
                (preview.map(skill => (
                    <Badge
                        key={skill}
                        bg="primary"
                        className="bg-opacity-10 border border-primary border-opacity-25"
                        style={{ 
                            fontSize: "10px",
                            fontWeight: 500,
                            padding: "4px 8px",
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100px" 
                        }}
                    >
                        {skill}
                    </Badge>
                )))}

                {hiddenCount > 0 && (
                    <Badge
                        bg="primary"
                        className="bg-opacity-10 border border-secondary border-opacity-25"
                        style={{ fontSize: 10, fontWeight: 500, padding: "4px 8px" }}
                    >
                        {isTable ? `+${hiddenCount} skills`:`+${hiddenCount}`}
                    </Badge>
                )}
            </div>
        </OverlayTrigger>
      )}

    </>
  );
}

export function EductionCell({ eductionList, numShow=3, isTable, isApp=false, isGrid=false, studentEdu }) {
//   const edu = isApp ? eductionList: eductionList?.split(",")?.map(s => s?.trim())?.filter(Boolean) ?? [];
 const edu = Array.isArray(eductionList)
    ? eductionList
    : eductionList
        ?.split(",")
        ?.map(s => s.trim())
        ?.filter(Boolean) ?? [];
  const preview = edu?.slice(0, numShow);
  const hiddenCount = Math.max(edu?.length - preview.length, 0);
  const getMarksText = (marks = []) => {
    if (!marks.length) return "-";
    return marks
        .map(m => `${m.studying_year}: ${m.marks_obtained} ${m.marks_type}`)
        .join(", ");
  };

  const isSchoolDegree = (degree) => ["10th", "12th"].includes(degree);
  const formatMarks = (edu) => {
    if (!edu?.marks?.length) return "-";

    if (isSchoolDegree(edu.degree_title)) {
        const mark = edu.marks[0];
        return `${mark.marks_obtained}%`;
    }

    return edu.marks.map((m, i) => (
        <div key={i}>
        <strong>{m.studying_year}:</strong>{" "}
        {m.marks_obtained} {m.marks_type?.toUpperCase()}
        </div>
    ));
    };


  const renderPopover = (
    <Popover
        id="edu-popover"
        style={{
        boxShadow: "2px 4px 12px rgba(0,0,0,0.15)",
        borderRadius: "8px",
        minWidth: "400px"
        }}
    >
        <Popover.Header as="h6" className="fw-semibold">
        Education Details
        </Popover.Header>

        <Popover.Body style={{ maxHeight: "320px", overflowY: "auto" }}>
        <Table bordered hover size="sm" className="mb-0">
            <thead className="table-light">
                <tr style={{ fontSize: 12 }}>
                <th>#</th>
                <th>Degree</th>
                <th>Academic Year</th>
                <th>Marks</th>
                </tr>
            </thead>

            <tbody>
                {Array.isArray(studentEdu) && studentEdu.map((edu, index) => (
                <tr key={edu.id} style={{ fontSize: 12 }}>
                    <td>{index + 1}</td>

                    {/* Degree */}
                    <td>
                    <strong>{edu.degree_title}</strong>
                    {!isSchoolDegree(edu.degree_title) && edu.studying_year && (
                        <div className="text-muted" style={{ fontSize: 11 }}>
                        {edu.studying_year}
                        </div>
                    )}
                    </td>

                    {/* Academic Year */}
                    <td>
                    {isSchoolDegree(edu.degree_title)
                        ? edu.year
                        : edu.year || "-"}
                    </td>

                    {/* Marks */}
                    <td>
                    {formatMarks(edu)}
                    </td>
                </tr>
                ))}
            </tbody>
        </Table>
        </Popover.Body>
    </Popover>
    );
    // const renderPopover = (
    //     <Popover
    //         id="edu-popover"
    //         style={{
    //             boxShadow: "2px 4px 12px rgba(0,0,0,0.15)",
    //             borderRadius: "8px",
    //         }}
    //     >
    //         <Popover.Header as="h6" className="fw-semibold">Education List</Popover.Header>
    //         <Popover.Body style={{ maxHeight: "auto", overflowY: "auto" }}>
    //             <div className="d-flex flex-wrap gap-1">
    //                 {edu?.map((ed, i) => (
    //                 <Badge
    //                     key={i}
    //                     bg="primary"
    //                     className="bg-opacity-10 border border-primary border-opacity-25"
    //                     style={{ fontSize: 11, 
    //                         fontWeight: 500, 
    //                         padding: "4px 8px",
    //                         maxWidth: 380,
    //                         whiteSpace: "normal",
    //                         letterSpacing:0.5,
    //                         wordBreak: "break-word",
    //                         overflowWrap: "break-word",
    //                         display: "inline-block"
    //                     }}
    //                 >
    //                     {ed}
    //                 </Badge>
    //                 ))}
    //             </div>
    //         </Popover.Body>
    //     </Popover>
    // );
  return (
    <>

      {preview?.length === 0 ? "No Education Found." :(
        <OverlayTrigger
            placement="bottom"
            overlay={renderPopover}
            delay={{ show: 100, hide: 200 }}
        >
            <div className="d-flex flex-wrap gap-1 cursor-pointer">
                {isTable ||
                (preview.map(ed => (
                    <Badge
                        key={ed}
                        bg="primary"
                        className="bg-opacity-10 border border-primary border-opacity-25"
                        style={{ 
                            fontSize: "10px",
                            fontWeight: 500,
                            padding: "4px 8px",
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: isGrid? "180px":"100px" 
                        }}
                    >
                        {ed}
                    </Badge>
                )))}

                {hiddenCount > 0 && (
                    <Badge
                        bg="primary"
                        className="bg-opacity-10 border border-secondary border-opacity-25"
                        style={{ fontSize: 10, fontWeight: 500, padding: "4px 8px" }}
                    >
                        {isTable ? `+${hiddenCount} eduction`:`+${hiddenCount}`}
                    </Badge>
                )}
            </div>
        </OverlayTrigger>
      )}
    </>
  );
}


export default StudentCard